var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-component",
      class: { mobile: _vm.mobileBigAndBelow }
    },
    [
      _vm.eventsLoaded
        ? _c("div", { staticClass: "header-text" }, [
            _c("h2", [
              _vm._v(
                '"' +
                  _vm._s(_vm.searchPhrase) +
                  '" ' +
                  _vm._s(_vm.$t("Search.Results")) +
                  " (" +
                  _vm._s(_vm.numberOfHits) +
                  ")"
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventsLoaded &&
      _vm.searchResultsProcessed &&
      _vm.searchResultsProcessed.length > 0
        ? _c(
            "div",
            { staticClass: "sports" },
            [
              _c(
                "v-tabs",
                { attrs: { "fixed-tabs": "", "align-with-title": "" } },
                _vm._l(_vm.searchResultsProcessed, function(
                  fosporttype,
                  index
                ) {
                  return _c(
                    "v-tab",
                    {
                      key: index,
                      class: [
                        "tab",
                        {
                          active:
                            _vm.selectedSportTypeComputed.idfosporttype ===
                            fosporttype.idfosporttype
                        }
                      ],
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.selectSportType(fosporttype)
                        }
                      }
                    },
                    [
                      _vm._v("\n        " + _vm._s(fosporttype.name) + " "),
                      fosporttype.eventcount
                        ? _c("span", { staticClass: "numberOfEvents" }, [
                            _vm._v(_vm._s(fosporttype.eventcount))
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eventsLoaded &&
      _vm.searchResultsProcessed &&
      _vm.searchResultsProcessed.length > 0
        ? [
            _vm.selectedSportTypeComputed &&
            _vm.selectedSportTypeComputed.fosports &&
            _vm.selectedSportTypeComputed.fosports.length > 0
              ? _c(
                  "section",
                  { staticClass: "fosports" },
                  _vm._l(_vm.selectedSportTypeComputed.fosports, function(
                    fosport
                  ) {
                    return _c(
                      "div",
                      {
                        key: fosport.idfosport,
                        staticClass: "fosport-container",
                        class: { noexplicitfound: !fosport.explicitlyfound }
                      },
                      [
                        fosport.explicitlyfound
                          ? _c(
                              "div",
                              {
                                staticClass: "sporttitle",
                                class: { clickable: fosport.explicitlyfound },
                                on: {
                                  click: function($event) {
                                    return _vm.goToFoSport(fosport)
                                  }
                                }
                              },
                              [
                                _c(
                                  "h2",
                                  { staticClass: "sportname" },
                                  [
                                    fosport.explicitlyfound
                                      ? _c(
                                          "text-highlight",
                                          {
                                            attrs: {
                                              queries:
                                                _vm.searchPhraseWithSynonims
                                            }
                                          },
                                          [_vm._v(_vm._s(" " + fosport.name))]
                                        )
                                      : [_vm._v(_vm._s(fosport.name))]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "viewsportcompetition clickable"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Search.ViewMore")))]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        fosport &&
                        fosport.focompetitions &&
                        fosport.focompetitions.length > 0
                          ? _c(
                              "section",
                              { staticClass: "focompetitions" },
                              _vm._l(
                                fosport.focompetitions.filter(function(focomp) {
                                  return (
                                    focomp.explicitlyfound ||
                                    (focomp.events && focomp.events.length > 0)
                                  )
                                }),
                                function(focompetition) {
                                  return _c(
                                    "div",
                                    {
                                      key: focompetition.idfocompetition,
                                      staticClass: "focompetition-container",
                                      class: {
                                        hasevents:
                                          focompetition.events &&
                                          focompetition.events.length > 0
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "competitiontitle",
                                          class: {
                                            clickable:
                                              focompetition.explicitlyfound
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.goToFoCompetition(
                                                fosport,
                                                focompetition
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("h2", [
                                            _c(
                                              "span",
                                              [
                                                fosport.explicitlyfound
                                                  ? _c(
                                                      "text-highlight",
                                                      {
                                                        attrs: {
                                                          queries:
                                                            _vm.searchPhraseWithSynonims
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            " " + fosport.name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : [
                                                      _vm._v(
                                                        _vm._s(fosport.name)
                                                      )
                                                    ],
                                                _vm._v(
                                                  "\n                   - \n                "
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "competitionname"
                                              },
                                              [
                                                focompetition.explicitlyfound
                                                  ? _c(
                                                      "text-highlight",
                                                      {
                                                        attrs: {
                                                          queries:
                                                            _vm.searchPhraseWithSynonims
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            " " +
                                                              focompetition.name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : [
                                                      _vm._v(
                                                        _vm._s(
                                                          focompetition.name
                                                        )
                                                      )
                                                    ]
                                              ],
                                              2
                                            )
                                          ]),
                                          _vm._v(" "),
                                          focompetition.explicitlyfound
                                            ? _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "viewsportcompetition clickable"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Search.ViewMore")
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      focompetition.events &&
                                      focompetition.events.length > 0
                                        ? _c("div", { staticClass: "events" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "events-container"
                                              },
                                              [
                                                focompetition.events.filter(
                                                  function(ev) {
                                                    return ev.liveEvent
                                                  }
                                                ).length
                                                  ? _c("big3-markets-header", {
                                                      attrs: {
                                                        coupontitle: "",
                                                        "has-draw":
                                                          focompetition.hasdraw,
                                                        "is-big3-coupon":
                                                          focompetition.isbig3coupon,
                                                        "max-no-of-selections":
                                                          focompetition.maxnumberofselections,
                                                        idfosporttype: ""
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  focompetition.events.filter(
                                                    function(ev) {
                                                      return ev.liveEvent
                                                    }
                                                  ),
                                                  function(event, $index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event live",
                                                        class: [
                                                          _vm
                                                            .selectedSportTypeComputed
                                                            .idfosporttype,
                                                          {
                                                            last:
                                                              $index ===
                                                              focompetition.events.filter(
                                                                function(ev) {
                                                                  return ev.liveEvent
                                                                }
                                                              ).length -
                                                                1
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        event.liveEvent
                                                          .idfosporttype &&
                                                        [
                                                          "GOLF",
                                                          "MOTORSPORT",
                                                          "NASCAR"
                                                        ].indexOf(
                                                          event.liveEvent
                                                            .idfosporttype
                                                        ) > -1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "outright-golf outright-event-name"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "name"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "text-highlight",
                                                                      {
                                                                        attrs: {
                                                                          queries:
                                                                            _vm.searchPhraseWithSynonims
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            " " +
                                                                              event.name
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            staticClass:
                                                              "wrapper"
                                                          },
                                                          [
                                                            _c(
                                                              "live-event-info",
                                                              {
                                                                attrs: {
                                                                  event:
                                                                    event.liveEvent,
                                                                  page:
                                                                    "coupon",
                                                                  threeselections:
                                                                    !focompetition.isbig3coupon &&
                                                                    focompetition.hasdraw,
                                                                  twoselections:
                                                                    !focompetition.isbig3coupon &&
                                                                    !focompetition.hasdraw,
                                                                  isbig3coupon:
                                                                    focompetition.isbig3coupon,
                                                                  phrasetohighlight:
                                                                    _vm.searchPhraseWithSynonims
                                                                }
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            event.liveEvent
                                                              .markets &&
                                                            event.liveEvent
                                                              .markets.length >
                                                              0
                                                              ? _c("markets", {
                                                                  attrs: {
                                                                    markets: !focompetition.isbig3coupon
                                                                      ? [
                                                                          event
                                                                            .liveEvent
                                                                            .markets[0]
                                                                        ]
                                                                      : event
                                                                          .liveEvent
                                                                          .markets,
                                                                    event:
                                                                      event.liveEvent,
                                                                    pricechangehighlight: true,
                                                                    islivepredefined: true,
                                                                    "is-big3-coupon":
                                                                      focompetition.isbig3coupon
                                                                  }
                                                                })
                                                              : _c(
                                                                  "section",
                                                                  {
                                                                    staticClass:
                                                                      "nomarkets"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Sports.NoAvailableMarkets"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                            _vm._v(" "),
                                                            (!_vm.mobileBigAndBelow &&
                                                              _vm.brandLayout !==
                                                                "generic" &&
                                                              _vm.brandKey !==
                                                                "sb" &&
                                                              _vm.brandKey !==
                                                                "mav" &&
                                                              _vm.brandKey !==
                                                                "qcasino") ||
                                                            (_vm.mobileBigAndBelow &&
                                                              (_vm.brandKey ===
                                                                "dn" ||
                                                                _vm.brandKey ===
                                                                  "dnw" ||
                                                                _vm.brandKey ===
                                                                  "circa"))
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "more-markets",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.goToEvent(
                                                                          event
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm.brandKey !==
                                                                      "dn" &&
                                                                    _vm.brandKey !==
                                                                      "dnw" &&
                                                                    _vm.brandKey !==
                                                                      "circa"
                                                                      ? _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "add"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _vm.brandKey ===
                                                                      "dn" ||
                                                                    _vm.brandKey ===
                                                                      "dnw" ||
                                                                    _vm.brandKey ===
                                                                      "circa"
                                                                      ? _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "chevron_right"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "live-coupon-event-footer",
                                                          {
                                                            attrs: {
                                                              event:
                                                                event.liveEvent,
                                                              phraseToHighlight:
                                                                _vm.searchPhraseWithSynonims,
                                                              additionalFound:
                                                                event.numberOfHits >
                                                                1
                                                                  ? event.foundphrase +
                                                                    ", ..."
                                                                  : event.foundphrase
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                focompetition.events.filter(
                                                  function(ev) {
                                                    return ev.liveEvent
                                                  }
                                                ).length > 0 &&
                                                focompetition.events.filter(
                                                  function(ev) {
                                                    return !ev.liveEvent
                                                  }
                                                ).length > 0
                                                  ? _c("h3", [
                                                      _vm._v("More results")
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  focompetition.events.filter(
                                                    function(ev) {
                                                      return !ev.liveEvent
                                                    }
                                                  ),
                                                  function(event, $index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event prematch",
                                                        class: [
                                                          _vm
                                                            .selectedSportTypeComputed
                                                            .idfosporttype,
                                                          {
                                                            last:
                                                              $index ===
                                                              focompetition
                                                                .events.length -
                                                                1
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        $index === 0
                                                          ? _c(
                                                              "v-flex",
                                                              {
                                                                staticClass:
                                                                  "header wrapper"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Search.Header.Time"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "event-name"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Search.Header.Event"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "more-markets"
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            staticClass:
                                                              "eventinfo wrapper clickable",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.goToEvent(
                                                                  event
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm.isDateToday(
                                                              event.tsstart
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Search.Today"
                                                                        )
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "moment"
                                                                          )(
                                                                            event.tsstart,
                                                                            _vm
                                                                              .dateFormats
                                                                              .longTime
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.isDateTomorrow(
                                                              event.tsstart
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Search.Tomorrow"
                                                                        )
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "moment"
                                                                          )(
                                                                            event.tsstart,
                                                                            _vm
                                                                              .dateFormats
                                                                              .longTime
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            !_vm.isDateToday(
                                                              event.tsstart
                                                            ) &&
                                                            !_vm.isDateTomorrow(
                                                              event.tsstart
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "moment"
                                                                        )(
                                                                          event.tsstart,
                                                                          _vm
                                                                            .dateFormats
                                                                            .longDateTime
                                                                        )
                                                                      ) + " "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "event-name"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "name"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "text-highlight",
                                                                      {
                                                                        attrs: {
                                                                          queries:
                                                                            _vm.searchPhraseWithSynonims
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            " " +
                                                                              event.name
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                event.foundphrase
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "additional-found"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "text-highlight",
                                                                          {
                                                                            attrs: {
                                                                              queries:
                                                                                _vm.searchPhraseWithSynonims
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                " " +
                                                                                  event.foundphrase
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        event.numberOfHits >
                                                                        1
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  ", ..."
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "more-markets"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "arrowright"
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.searchPhrase &&
                _vm.playerFavorites &&
                _vm.isLoggedIn &&
                _vm.allPlayerFavorites &&
                _vm.allPlayerFavorites.length > 0,
              expression:
                "!searchPhrase && playerFavorites && isLoggedIn && allPlayerFavorites && allPlayerFavorites.length > 0"
            }
          ],
          staticClass: "favorites_on_search_page"
        },
        [
          _c("div", { staticClass: "favorites_header" }, [
            _vm._v(_vm._s(_vm.$t("Favorites.MyEvents.Tabs.Favorites")))
          ]),
          _vm._v(" "),
          _vm._l(_vm.allPlayerFavorites, function(favorit, index) {
            return _c("div", { key: index, staticClass: "favorite-item" }, [
              favorit.type === "P" || favorit.type === "C"
                ? _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          return _vm.searchFavorite(favorit.name)
                        }
                      }
                    },
                    [_vm._v(_vm._s(favorit.name))]
                  )
                : _vm._e(),
              _vm._v(" "),
              favorit.type === "S" || favorit.type === "L"
                ? _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          return _vm.searchFavorite(favorit.idfosporttype)
                        }
                      }
                    },
                    [_vm._v(_vm._s(favorit.idfosporttype))]
                  )
                : _vm._e()
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                (!_vm.searchPhrase ||
                  _vm.searchPhrase.length < _vm.numOfCharsToStartSearch) &&
                (!(
                  _vm.allPlayerFavorites && _vm.allPlayerFavorites.length > 0
                ) ||
                  !_vm.playerFavorites ||
                  !_vm.isLoggedIn),
              expression:
                "(!searchPhrase || searchPhrase.length < numOfCharsToStartSearch) && (!(allPlayerFavorites && allPlayerFavorites.length > 0) || !playerFavorites || !isLoggedIn)"
            }
          ],
          staticClass: "before-search-start"
        },
        [
          _c("div", { staticClass: "header" }, [
            _vm._v(_vm._s(_vm.$t("Search.SearchForCompetitionsTeamsPlayers")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body" }, [
            _vm._v(_vm._s(_vm.$t("Search.ResultsWillShowAsYouType")))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.searchPhrase &&
                _vm.searchPhrase.length >= _vm.numOfCharsToStartSearch &&
                !_vm.eventsLoaded,
              expression:
                "searchPhrase && searchPhrase.length >= numOfCharsToStartSearch && !eventsLoaded"
            }
          ],
          staticClass: "search-loading"
        },
        [
          _c("dots-loader"),
          _vm._v(" "),
          _c("div", { staticClass: "header" }, [
            _vm._v(_vm._s(_vm.$t("Search.Loading")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.searchPhrase &&
                _vm.searchPhrase.length >= _vm.numOfCharsToStartSearch &&
                _vm.eventsLoaded &&
                !(
                  _vm.searchResultsProcessed &&
                  _vm.searchResultsProcessed.length > 0
                ),
              expression:
                "searchPhrase && searchPhrase.length >= numOfCharsToStartSearch && eventsLoaded && !(searchResultsProcessed && searchResultsProcessed.length > 0)"
            }
          ],
          staticClass: "search-no-results"
        },
        [
          _c("div", { staticClass: "header" }, [
            _vm._v(_vm._s(_vm.$t("Search.NoResultsFound")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body" }, [
            _c("div", { staticClass: "suggestions" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("Search.Suggestions")))]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _vm._v(" - " + _vm._s(_vm.$t("Search.Suggestions_1")))
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(" - " + _vm._s(_vm.$t("Search.Suggestions_2")))
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(" - " + _vm._s(_vm.$t("Search.Suggestions_3")))
                ])
              ])
            ])
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-429067ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429067ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/SearchResults.vue
// module id = null
// module chunks = 